import template from './deposit.jade';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

export default angular
  .module('cian.addForm.bargainTermsDeposit', [])
  .directive('cianAfPriceAndDealTermsDeposit', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(
      $timeout,
      $scope,
      isSimpleFormEnabled,
      adTooltipsService,
      analyticsService,
      deviceService,
      popupService,
    ) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Залог собственнику';
      this.tooltipText = '';
      this.hintText = `
            <b>Залог</b> – является страховым депозитом.
            Эта выплата арендатора хозяину
            квартиры дает гарантии того, что
            возможный ущерб имущества будет
            возмещен залогом.<br/><br/>
            <b>Предоплата</b> - сумма, которую
            оплачивает арендатор вперед, за период
            проживания. Как правило собственники
            жилья просят предоплату за последний
            месяц, в редких случаях, за второй и
            последний месяцы проживания.
          `;
      this.isSimpleFormEnabled = isSimpleFormEnabled;
      this.noDeposit = false;
      this.isDepositEnabled = true;

      this.setNoDeposit = () => {
        this.ad.bargainTerms.deposit = undefined;

        if (
          this.form['bargainTerms.deposit'] &&
          typeof this.form['bargainTerms.deposit'].$setUntouched === 'function'
        ) {
          this.form['bargainTerms.deposit'].$setUntouched();
        }
      };

      $scope.$watch(
        () => this.ad.bargainTerms.deposit,
        deposit => {
          if (isSimpleFormEnabled()) {
            if (deposit) {
              this.noDeposit = false;
            } else if (deposit === 0) {
              this.noDeposit = true;
              this.setNoDeposit();
            }
          }
        },
      );

      this.isInputFieldRequired = () => {
        return !isSimpleFormEnabled() || !this.noDeposit;
      };

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'bargainTerms.deposit',
        trackingLabel: 'deposit-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
    controllerAs: 'deposit',
    template,
  })).name;
